import {AuthorizationsParams} from './get-authorizations';

export enum AuthRequestStatusEnum {
	TODOS = 'TODOS',
	REGISTRADO = 'REGISTRADO',
	PENDENTE = 'PENDENTE',
	CONCLUIDO = 'CONCLUIDO',
}

export type AuthRequest = {
	nuControle: string;
	dsSituacao: AuthRequestStatusEnum | string;
	dtAutorizacao: string;
	nuProtocolo: string;
	qtdNovasMsgs: number;
};

export type ContentRequests = {
	items: AuthRequest[];
	total: number;
	page: number;
	size: number;
	pages: number;
};

export type GetAuthRequestsModel = ContentRequests;

export interface GetAuthRequests {
	get: (params?: AuthorizationsParams) => Promise<GetAuthRequestsModel>;
}
